// utilsThemeLogic.js
import { themeTime } from "./theme";
let currentTheme = "day";

export const setThemeGlobally = (theme) => {
  if (theme === "auto") {
    const detectedTheme = themeTime();
    currentTheme = detectedTheme;
  } else {
    currentTheme = theme;
  }
  document.documentElement.setAttribute("data-theme", currentTheme);
  localStorage.setItem("theme", currentTheme);
};

export const getCurrentTheme = () => {
  return currentTheme;
};

export const initializeTheme = () => {
  const savedTheme = localStorage.getItem("theme") || "auto";
  if (savedTheme === "auto") {
    currentTheme = themeTime();
  } else {
    currentTheme = savedTheme;
  }
  document.documentElement.setAttribute("data-theme", currentTheme);
};
